import { render, staticRenderFns } from "./msgTitle1.vue?vue&type=template&id=6a29a95c&scoped=true&"
import script from "./msgTitle1.vue?vue&type=script&lang=js&"
export * from "./msgTitle1.vue?vue&type=script&lang=js&"
import style0 from "./msgTitle1.vue?vue&type=style&index=0&id=6a29a95c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a29a95c",
  null
  
)

export default component.exports